import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const TableApi = createApi({
  reducerPath: "TableApi",
  baseQuery: authBaseQuery,
  endpoints: (builder) => ({
    getDynamicTableData: builder.query({
      query: ({ loginUserId, tableName }) =>
        `get_dynamic_table_data?userId=${loginUserId}&tableName=${tableName}`,
      transformResponse: (response) => response?.data || [],
    }),

    addTableData: builder.mutation({
      query: (data) => ({
        url: "add_dynamic_table_data",
        method: "POST",
        body: data,
      }),
    }),
    editTableData: builder.mutation({
      query: (data) => ({
        url: `edit_dynamic_table_data`,
        method: "PUT",
        body: data,
      }),
    }),
  }),
});

export const {
  useGetDynamicTableDataQuery,
  useAddTableDataMutation,
  useEditTableDataMutation,
} = TableApi;

export default TableApi;
